import { render, staticRenderFns } from "./newBranch.vue?vue&type=template&id=1db91b68&scoped=true&"
import script from "./newBranch.vue?vue&type=script&lang=ts&"
export * from "./newBranch.vue?vue&type=script&lang=ts&"
import style0 from "./newBranch.vue?vue&type=style&index=0&id=1db91b68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db91b68",
  null
  
)

export default component.exports